export const ugColumns = [
  { field: "specialization", headerName: "B.Tech Specialization", width: 400 },
  { field: "name", headerName: "Expert name and designation", width: 600 },
];

export const ugRows = [
  {
    id: 1,
    specialization: "Civil Engineering",
    name: "Dr.K.C.B.Rao, Prof in ECE & Director of Academic Planning",
  },
  {
    id: 2,
    specialization: "CSE - Computer Science and Engineering - Cyber Scurity ",
    name: "Dr.D.Rajya Lakshmi, Prof in CSE & Director of Evaluation",
  },
  {
    id: 3,
    specialization: "CSE - Computer Science and Engineering",
    name: "Dr.D.Rajya Lakshmi, Prof in CSE & Director of Evaluation",
  },
  {
    id: 4,
    specialization: "CSE - Artificial Intelligence and Data Science",
    name: "Dr.R.Rajeshwara Rao, Prof in CSE & Director of Academic and Audit",
  },
  {
    id: 5,
    specialization: "CSE - Artificial Intelligence and Machine Learning",
    name: "Dr.G.Jaya Suma, Prof in IT & Director of Industry,Institute Interaction Placements & Training i/c",
  },
  {
    id: 6,
    specialization: "CSE - Data Science",
    name: "Dr.G.Jaya Suma, Prof in IT & Director of Industry,Institute Interaction Placements & Training i/c",
  },
  {
    id: 7,
    specialization: "CSE - Internet of Things",
    name: "Dr.D.Rajya Lakshmi, Prof in CSE & Director of Evaluation",
  },
  {
    id: 8,
    specialization: "EEE",
    name: "Dr.K.Sri Kumar, Prof in EEE & Pricncipal, CEV",
  },
  {
    id: 9,
    specialization: "ECE",
    name: "Dr,K.Babulu, Prof in ECE & Director of Research and Development & Admissions",
  },
  {
    id: 10,
    specialization: "Mechanical Engineering",
    name: "Dr.Swami Naidu.G, Prof in Metallurgical Engineering & Registrar",
  },
  {
    id: 11,
    specialization: "Automobile Engineering",
    name: "Dr.K.C.B.Rao, Prof in ECE & Director of Academic Planning",
  },
  {
    id: 12,
    specialization: "Information Technology",
    name: "Dr.R.Rajeshwara Rao, Prof in CSE & Director of Academic and Audit",
  },
  {
    id: 13,
    specialization: "B. Pharmacy",
    name: "Dr.K.C.B.Rao, Prof in ECE & Director of Academic Planning",
  },
  {
    id: 14,
    specialization: "Pharma D",
    name: "Dr.K.C.B.Rao, Prof in ECE & Director of Academic Planning",
  },
  {
    id: 15,
    specialization: "Mathematics",
    name: "Dr.A.V.Papa Rao, Asst Prof in Mathemetics",
  },
  {
    id: 16,
    specialization: "Physics",
    name: "Dr.G.J.Naga Raju, Asst Prof in Physics",
  },
  {
    id: 17,
    specialization: "Chemistry",
    name: "Dr.M.Sowbhagya Lakshmi, Asst Prof in Chemistry",
  },
  {
    id: 18,
    specialization: "English",
    name: "Dr.K.C.B.Rao, Prof in ECE & Director of Academic Planning",
  },
];
